import moment from 'moment';
import { remove } from 'lodash';
import { getTranslationKey } from '../modules/utils/helpers';
import type { Action } from '../typings/reducers';

type Appointment = {
  _id: string;
  start?: string | Date;
  end?: string | Date;
  title?: string;
  type?: string;
  lead?: { first_name: string; last_name: string };
};

type AppointmentState = { allAppointments: Appointment[]; isTimeSlotPopUpOpen: boolean };

function castAppointmentDates(appointment: Appointment) {
  if (appointment.start) appointment.start = moment(appointment.start).toDate();
  if (appointment.end) appointment.end = moment(appointment.end).toDate();
}

function setAppoinmentTitle(appointment: Appointment) {
  if (!appointment.title) {
    appointment.title = appointment.type
      ? getTranslationKey(`shootingTypes.${appointment.type}`)
      : '';
    if (appointment.lead) {
      const { lead } = appointment;
      appointment.title +=
        (appointment.title.length > 0 && ' - ') + lead.first_name + ' ' + lead.last_name;
    }
  }
}

export default function (
  state: AppointmentState = { allAppointments: [], isTimeSlotPopUpOpen: false },
  action: Action
): AppointmentState {
  switch (action.type) {
    case 'SET_ALL_APPOINTMENTS':
      const allAppointments: Appointment[] = (action.payload as Appointment[]).map(
        (appointment) => {
          castAppointmentDates(appointment);
          setAppoinmentTitle(appointment);

          return appointment;
        }
      );

      return { ...state, allAppointments };
    case 'TOGGLE_TIMESLOT_POPUP':
      return { ...state, isTimeSlotPopUpOpen: !state.isTimeSlotPopUpOpen };
    case 'ADD_APPOINTMENT':
      const appointment: Appointment = action.payload;
      castAppointmentDates(appointment);
      setAppoinmentTitle(appointment);

      return {
        ...state,
        allAppointments: [action.payload, ...state.allAppointments]
      };
    case 'REMOVE_APPOINTMENT':
      const removeArray = state.allAppointments.slice();
      remove(removeArray, (item: Appointment) => item._id === (action.payload as string));

      return {
        ...state,
        allAppointments: [...removeArray]
      };
    case 'EDIT_APPOINTMENT':
      const changedAppointment: Appointment = action.payload;
      const editedAppointments = state.allAppointments.map((appointment) => {
        if (appointment._id !== changedAppointment._id) return appointment;
        castAppointmentDates(changedAppointment);
        setAppoinmentTitle(changedAppointment);

        return changedAppointment;
      });

      return {
        ...state,
        allAppointments: editedAppointments
      };
    default:
      return state;
  }
}
